import buildTheme from '../theme_builder';
/* eslint-disable */

const theme = buildTheme(['#95A72A', '#0080BB', '#10CFC9', '#F69627', '#FF671D', '#FF8F88', '#A952A5']);

export default theme;
